<footer style="min-height: 5vh;" id="sticky-footer" class="py-3 bg-dark text-white-50">
    <div class="container text-center">
      <small>Copyright &copy; Movired 2000 S.L</small>
    </div>
</footer>